import LotteryGGLV2Prefab, {HongPrizeEntity} from "./LotteryGGLV2Prefab";
import O1HD from "../../../../../engines/gameEngine";
import Hong2ItemNode from "./Hong2ItemNode";
import Hong3ItemNode from "./Hong3ItemNode";
import getValueMapFromData = jsb.fileUtils.getValueMapFromData;

const {ccclass, property} = cc._decorator;

@ccclass
export default class Hong3Node extends cc.Component {

    @property(cc.Node)
    maskNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"item预制体"})
    hong1ItemPrefab : cc.Prefab = null;
    @property({type:cc.Node,displayName:"内容节点"})
    contentNode : cc.Node = null;
    @property(LotteryGGLV2Prefab)
    mParentScript : LotteryGGLV2Prefab = null;
    @property(cc.Label)
    lbPrizeNum : cc.Label = null;
    @property(cc.Node)
    goldNode : cc.Node = null;
    @property(cc.Node)
    lotteryGoldNode : cc.Node = null;
    @property({type:cc.Node,displayName:"元宝"})
    ingotNode : cc.Node = null;

    @property({type:cc.Node,displayName:""})
    judgePrizeNode : cc.Node = null;

    private eggFlag : boolean = false;

    //已经打开的奖项
    hasOpenArray : string[] = [];
    private mCurrPrizeNum : number = 1;//当前中奖 Num


    onLoad () {
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchstart",this.touchStart.bind(this) );
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchmove",this.touchMove.bind(this) );

        O1HD.on("Hong3Node.reset" , this.reset , this );
        O1HD.on("Hong3Node.eggOpenPrize" , this.eggOpenPrize , this );
        O1HD.on("openGoldEffect" , this.openGoldEffect , this );
        O1HD.on("gglEggFour" , this.gglEggFour , this );
        //黄金彩票
        O1HD.on("activeLotteryGold" , this.activeLotteryGold , this );
    }


    start () {
        this.reset();
    }

    refreshData(){
        this.mCurrPrizeNum = Math.floor( Math.random() * 99 ) + 1;
        this.lbPrizeNum.string = `${this.mCurrPrizeNum}`;
        for ( let i = 0 ; i < 10 ; i ++ ) {
            let hongItemNode = cc.instantiate( this.hong1ItemPrefab );
            hongItemNode.getComponent( Hong3ItemNode ).bindData( this , `c${i}` ,this.mCurrPrizeNum );
            this.contentNode.addChild( hongItemNode );
        }
    }

    touchStart(e:cc.Event.EventTouch){

    }
    touchMove(e:cc.Event.EventTouch){
        if ( this.eggFlag ) {
            return;
        }
        let distance = Math.abs( Math.floor( e.getLocation().sub( e.getPreviousLocation() ).mag() ) );
        if ( distance > 5 ) {
            //补点操作
            for ( let num = 0 ; num < distance ; num += 3 ) {
                let subLocation : cc.Vec2 = e.getLocation().sub( e.getPreviousLocation() );
                let actualLocation = e.getPreviousLocation().add( subLocation.div( distance ).mul( num ) );
                this._addCircle( this.maskNode.convertToNodeSpaceAR( actualLocation ) );
                O1HD.emit("Hong3ItemNode.checkJudgeNode" , actualLocation );
            }
        }
        this._addCircle( this.maskNode.convertToNodeSpaceAR( e.getLocation() ) );
        this.checkJudgeNode( e.getLocation() );
        O1HD.emit("Hong3ItemNode.checkJudgeNode" , e.getLocation() );
    }

    private flagPrizeOpenFlag : boolean = false;
    /**
     * 检查是否过了 判断点
     * @param pos
     * @private
     */
    checkJudgeNode ( pos : cc.Vec2 ) {
        if ( this.judgePrizeNode.getBoundingBoxToWorld().contains( pos )  && this.flagPrizeOpenFlag == false ) {
            //hasOpen
            // console.log("flagPrizeOpenFlag" , this.flagPrizeOpenFlag );
            this.flagPrizeOpenFlag = true;
            O1HD.emit("Hong3ItemNode.triggerFlagPrizeOpen" , true );
        }
    }

    //效果渲染
    maskGraphicsPos1:cc.Vec2[] = [];
    _addCircle(pos:cc.Vec2){
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.circle (pos.x,pos.y, 20 )
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.fill();
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.stroke();
        this.maskGraphicsPos1.push(pos);
    }


    /**
     * 开奖
     */
    openPrize( hongDefine : HongPrizeEntity , node : cc.Node ){
        if ( hongDefine.flag ) {
            O1HD.getManagers().soundMgr.playSound("gglAddCoins").then();
            O1HD.getServices().userSrv.setCoins( hongDefine.prize , true , node );
        }
        this.hasOpenArray.push( hongDefine.uniqueId );
        // console.log( "this.hasOpenArray" , this.hasOpenArray );
        if ( this.hasOpenArray.length == 10 ) {
            cc.tween( this.maskNode )
                .to( 0.5 , { opacity : 100 })
                .call( ()=>{
                    this.maskNode.active = false;
                }).start();
            this.mParentScript.openPrize();
        }
    }

    reset(){
        O1HD.emit("Hong3ItemNode.remove" );
        this.goldNode.active = false;
        this.hasOpenArray = [];
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.clear();
        this.maskNode.opacity = 255;
        this.maskNode.active = true;
        this.flagPrizeOpenFlag = false;
        this.eggFlag = false;
        this.refreshData();
    }

    /**
     * 打开黄金效果
     */
    openGoldEffect( ){
        if( this.node ) {
            this.goldNode.opacity = 100;
            this.goldNode.active = true;
            this.eggFlag = true;
            cc.tween( this.goldNode )
                .to( 0.5 , {opacity : 255 })
                .start();
            //设置所有彩蛋奖项
            let hongPrizeEntity : HongPrizeEntity = {
                uniqueId : "egg",
                name : "egg",
                prize : 0,
                appearWeight : 0,
                weight : 0,
                flag : true,
            };
            let hongPrizeEntity1 = JSON.parse(JSON.stringify(( hongPrizeEntity )));
            hongPrizeEntity1.name = "1元";
            hongPrizeEntity1.prize = 1;
            let hongPrizeEntity5 = JSON.parse(JSON.stringify(( hongPrizeEntity )));
            hongPrizeEntity5.name = "5元";
            hongPrizeEntity5.prize = 5;
            let hongPrizeEntity10 = JSON.parse(JSON.stringify(( hongPrizeEntity )));
            hongPrizeEntity10.name = "10元";
            hongPrizeEntity10.prize = 10;
            let hongPrizeEntity20 = JSON.parse(JSON.stringify(( hongPrizeEntity )));
            hongPrizeEntity20.name = "20元";
            hongPrizeEntity20.prize = 20;
            let hongPrizeEntity30 = JSON.parse(JSON.stringify(( hongPrizeEntity )));
            hongPrizeEntity30.name = "30元";
            hongPrizeEntity30.prize = 30;
            let hongPrizeEntity666 = JSON.parse(JSON.stringify(( hongPrizeEntity )));
            hongPrizeEntity666.name = "666";
            hongPrizeEntity666.prize = 666;
            let hongPrizeEntity8888 = JSON.parse(JSON.stringify(( hongPrizeEntity )));
            hongPrizeEntity8888.name = "8888";
            hongPrizeEntity8888.prize = 8888;

            O1HD.emit("Hong3ItemNode.setEggPrize" , "c0" , hongPrizeEntity20 );
            O1HD.emit("Hong3ItemNode.setEggPrize" , "c1" , hongPrizeEntity1 );
            O1HD.emit("Hong3ItemNode.setEggPrize" , "c2" , hongPrizeEntity8888 );
            O1HD.emit("Hong3ItemNode.setEggPrize" , "c3" , hongPrizeEntity5 );
            O1HD.emit("Hong3ItemNode.setEggPrize" , "c4" , hongPrizeEntity10 );
            O1HD.emit("Hong3ItemNode.setEggPrize" , "c5" , hongPrizeEntity1 );
            O1HD.emit("Hong3ItemNode.setEggPrize" , "c6" , hongPrizeEntity5 );
            O1HD.emit("Hong3ItemNode.setEggPrize" , "c7" , hongPrizeEntity30 );
            O1HD.emit("Hong3ItemNode.setEggPrize" , "c8" , hongPrizeEntity1 );
            O1HD.emit("Hong3ItemNode.setEggPrize" , "c9" , hongPrizeEntity666 );
        }
    }

    /**
     * 第四天彩蛋
     */
    gglEggFour( ){
        if( this.node ) {
            //设置所有彩蛋奖项
            let hongPrizeEntity: HongPrizeEntity = {
                uniqueId: "egg",
                name: "egg",
                prize: 0,
                appearWeight: 0,
                weight: 0,
                flag: true,
            };
            let hongPrizeEntity1 = JSON.parse(JSON.stringify((hongPrizeEntity)));
            hongPrizeEntity1.name = "1元";
            hongPrizeEntity1.prize = 1;
            let hongPrizeEntity5 = JSON.parse(JSON.stringify((hongPrizeEntity)));
            hongPrizeEntity5.name = "5元";
            hongPrizeEntity5.prize = 5;
            let hongPrizeEntity10 = JSON.parse(JSON.stringify((hongPrizeEntity)));
            hongPrizeEntity10.name = "10元";
            hongPrizeEntity10.prize = 10;
            let hongPrizeEntity20 = JSON.parse(JSON.stringify((hongPrizeEntity)));
            hongPrizeEntity20.name = "20元";
            hongPrizeEntity20.prize = 20;
            let hongPrizeEntity30 = JSON.parse(JSON.stringify((hongPrizeEntity)));
            hongPrizeEntity30.name = "30元";
            hongPrizeEntity30.prize = 30;
            let hongPrizeEntity1111 = JSON.parse(JSON.stringify((hongPrizeEntity)));
            hongPrizeEntity1111.name = "1111";
            hongPrizeEntity1111.prize = 1111;

            O1HD.emit("Hong3ItemNode.setEggPrize", "c0", hongPrizeEntity20);
            O1HD.emit("Hong3ItemNode.setEggPrize", "c1", hongPrizeEntity1);
            O1HD.emit("Hong3ItemNode.setEggPrize", "c2", hongPrizeEntity1111);
            O1HD.emit("Hong3ItemNode.setEggPrize", "c3", hongPrizeEntity5);
            O1HD.emit("Hong3ItemNode.setEggPrize", "c4", hongPrizeEntity10);
            O1HD.emit("Hong3ItemNode.setEggPrize", "c5", hongPrizeEntity1);
            O1HD.emit("Hong3ItemNode.setEggPrize", "c6", hongPrizeEntity5);
            O1HD.emit("Hong3ItemNode.setEggPrize", "c7", hongPrizeEntity30);
            O1HD.emit("Hong3ItemNode.setEggPrize", "c8", hongPrizeEntity1);
            O1HD.emit("Hong3ItemNode.setEggPrize", "c9", hongPrizeEntity20);
        }
    }

    /**
     *
     */
    eggOpenPrize(){
        //所有开奖
        cc.tween( this.maskNode )
            .to( 1,{ opacity : 50 })
            .call(()=>{
                this.maskNode.active = false;
                O1HD.getManagers().soundMgr.playSound("hh").then();
                O1HD.emit("Hong3ItemNode.autoPrize");
            })
            .start();
    }


    /**
     * 激活黄金 彩票
     */
    activeLotteryGold(){
        console.log("触发HOng3")
        this.lotteryGoldNode.active = true;
        this.ingotNode.active = true;
    }

}
